// v2.21 (owner [PASTI], docs/rencana/PECAH-SPK.md): one Jersey nota, one SPK per design. Pure helpers (no imports,
// Jest-tested). The server decides the split; these only build the form choices and texts.
export const MAKS_DESAIN = 10;

const nomor = (b) => parseInt(b?.desain_ke, 10) || 1;

// Designs in order of first appearance (the server numbers them the same way: "Desain 1, Desain 3" -> 1, 2)
export function urutanDesain(variasi = [], tambahan = []) {
  const urut = [];
  [...variasi, ...tambahan].forEach((b) => { if (!urut.includes(nomor(b))) urut.push(nomor(b)); });
  return urut.length ? urut : [1];
}

export const jumlahDesain = (variasi, tambahan) => urutanDesain(variasi, tambahan).length;

// The choices of a line: every design in use, plus one new design (up to the limit)
export function pilihanDesain(variasi = [], tambahan = []) {
  const maks = Math.max(1, ...[...variasi, ...tambahan].map(nomor));
  return Array.from({ length: Math.min(MAKS_DESAIN, maks + 1) }, (_, i) => i + 1);
}

// One line per SPK the server will make: "Desain 1 — 2 pcs (M 1, L 1): JR01 x2"
export function teksDesain(d) {
  const ukuran = Object.entries(d.ukuran || {}).map(([u, n]) => `${u} ${n}`).join(", ");
  return `Desain ${d.desain_ke} — ${d.pcs} pcs${ukuran ? ` (${ukuran})` : ""}${d.baris?.length ? `: ${d.baris.join(", ")}` : ""}`;
}

// The form starts with the Owner's default designer when that account is still in the list; "" = every designer
export function desainerAwal(bawaan, jenis, designers = []) {
  const id = bawaan?.[jenis]?.id;
  return id && designers.some((d) => d.id === id) ? id : "";
}
